import { cx } from 'cva'
import type { ComponentProps, FC } from 'react'

export type ToggleProps = Omit<ComponentProps<'div'>, 'children'> & {
	labelOne: string
	labelOneId: string
	labelTwo: string
	labelTwoId: string
	active: boolean
	buttonOneClick: () => void
	buttonTwoClick: () => void
}

export const Toggle: FC<ToggleProps> = ({
	labelOne,
	labelOneId,
	labelTwo,
	labelTwoId,
	active,
	buttonOneClick,
	buttonTwoClick,
	...props
}) => {
	const buttonBaseClasses =
		'text-h6 py-2 cursor-pointer transition-all duration-200 flex items-center justify-center border-(length:--stroke-sm)'
	const activeButtonClasses = 'bg-blue-shade-70 text-white border-blue-shade-70'
	const inactiveButtonClasses =
		'bg-white text-blue border-blue hover:bg-blue-tint-10 hover:border-blue-shade-40 hover:text-blue-shade-40 active:bg-blue-shade-70 active:text-white active:border-blue-shade-70'
	return (
		<div className="flex w-fit items-center justify-center" {...props}>
			<button
				id={labelOneId}
				className={cx(
					'rounded-l-md pr-3 pl-3.5',
					buttonBaseClasses,
					active === true ? activeButtonClasses : inactiveButtonClasses,
				)}
				onClick={buttonOneClick}
				aria-controls="toggle-grid-content"
				aria-expanded={active}
			>
				<span>{labelOne}</span>
			</button>
			<button
				id={labelTwoId}
				className={cx(
					'rounded-r-md pr-3.5 pl-3',
					buttonBaseClasses,
					active === false ? activeButtonClasses : inactiveButtonClasses,
				)}
				onClick={buttonTwoClick}
				aria-controls="toggle-map-content"
				aria-expanded={!active}
			>
				<span>{labelTwo}</span>
			</button>
		</div>
	)
}
